import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormLabel } from '../Form.styles.js';
import { RadioInputItem as RadioInputItem$1, RadioInput, RadioInputIndicator } from './RadioInput.styles.js';

var RadioInputItem = function (_a) {
    var value = _a.value, _b = _a.disabled, disabled = _b === void 0 ? false : _b, label = _a.label, _c = _a.name, name = _c === void 0 ? "" : _c, className = _a.className;
    var watch = useFormContext().watch;
    return (React.createElement(RadioInputItem$1, { className: className },
        React.createElement(RadioInput, { id: "".concat(name, "-").concat(value), "aria-label": "".concat(name, "-").concat(value), value: value, checked: watch(name) === value, disabled: disabled },
            React.createElement(RadioInputIndicator, { checked: watch(name) === value })),
        React.createElement(FormLabel, { noMargin: true, htmlFor: "".concat(name, "-").concat(value), className: "styled-label" }, label)));
};

export { RadioInputItem as default };
//# sourceMappingURL=RadioInputItem.js.map
